import {memo} from 'react';
import style from './style.module.scss';
import {IArticleType} from 'modules/blog/models';
import {useRouter} from 'next/router';
import classNames from 'classnames';
import Link from 'components/CustomRoutingLink';
import {Chips} from 'components/Chips';

interface IProps {
    articleTypes?: IArticleType[];
}

export const BlogNav = memo<IProps>(function BlogNav({articleTypes = []}) {
    const {query} = useRouter();

    const {articleX} = query;
    const autotestTargetName = articleX ? 'detail' : 'main';

    return (
        <div className={style.blogNav}>
            <ul className={style.list}>
                {articleTypes?.map((item: IArticleType) => {
                    return (
                        <li
                            key={`${item.id}-${item.code}`}
                            className={classNames(style.link, {
                                [style.activeCategory]: item.code === query.category,
                            })}
                        >
                            <Link href={`/articles/${item.code}`} legacyBehavior={true} passHref={true} shallow={true}>
                                <a
                                    data-autotest-target={`blog-${autotestTargetName}-category`}
                                    data-autotest-target-id={`blog-${autotestTargetName}-category-${item.id}`}
                                >
                                    <Chips
                                        className={classNames(style.text, {
                                            [style.activeCategory]: item.code === query.category,
                                        })}
                                        color={'gray100'}
                                    >
                                        {item.title}
                                    </Chips>
                                </a>
                            </Link>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
});
